import { createFileRoute } from '@tanstack/react-router';

import UnderDevelopment from '@src/pages/UnderDevelopment';

import { getLocalizedTitle } from '../title';

export const Route = createFileRoute('/_app/fleet/add')({
  head: () => ({
    meta: [{ title: getLocalizedTitle('fleet.add_vehicle', 'Add vehicle') }],
  }),
  component: UnderDevelopment,
});
